import { render, staticRenderFns } from "./AdminCourses.vue?vue&type=template&id=3b6988d4&"
import script from "./AdminCourses.vue?vue&type=script&lang=js&"
export * from "./AdminCourses.vue?vue&type=script&lang=js&"
import style0 from "./AdminCourses.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports